export const CLI_KIT_VERSION = '3.93.2'
